export default __webpack_public_path__ + "static/media/CFFundCardBanner.b9227edb.png";